"use strict";
/* globals module */
/**
 * @module commerceProductInstanceFilesBatchRoute
 * @description Baasic Product Instance Files Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Product Files Batch Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../../common");
var contracts_1 = require("../../../../core/contracts");
var CommerceProductInstanceFilesBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceProductInstanceFilesBatchRoute, _super);
    function CommerceProductInstanceFilesBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.unlinkRoute = 'products/{productId}/files/batch/unlink';
        _this.updateRoute = 'products/{productId}/files/batch';
        _this.linkRoute = 'products/{productId}/files/batch/link';
        return _this;
    }
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @param productId Product file id of the original product file used to identify product files on which delete action should be performed.
     * @example productInstanceFilesBatchRoute.unlink(productId);
     **/
    CommerceProductInstanceFilesBatchRoute.prototype.unlink = function (productId) {
        var params = { productId: productId };
        return _super.prototype.baseCreate.call(this, this.unlinkRoute, params);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param productId Product id which uniquely identifies product whose product file need to be updated.
     * @example productInstanceFilesStreamsRoute.update(productId);
     **/
    CommerceProductInstanceFilesBatchRoute.prototype.update = function (productId) {
        var params = { productId: productId };
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param productId Product slug or id which uniquely identifies product whose product files need to be linked.
     * @example productInstanceFilesStreamsRoute.link(productId);
     **/
    CommerceProductInstanceFilesBatchRoute.prototype.link = function (productId) {
        var params = { productId: productId };
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    var _a;
    CommerceProductInstanceFilesBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceProductInstanceFilesBatchRoute);
    return CommerceProductInstanceFilesBatchRoute;
}(common_1.BaseRoute));
exports.CommerceProductInstanceFilesBatchRoute = CommerceProductInstanceFilesBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/
